import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0A4F35] text-white mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo variant="text" />
            <p className="mt-4 max-w-sm text-sm text-emerald-100/80 leading-relaxed">
              Reliable bulk diesel and petrol supply for banks, manufacturers, churches and corporate
              organisations across Nigeria.
            </p>
            <p className="mt-4 text-xs text-emerald-100/60">RC: 1117437</p>
          </div>
          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-widest text-[#E5B800]">Company</h4>
            <ul className="mt-4 space-y-2 text-sm text-emerald-100/80">
              <li><Link to="/products" className="hover:text-white">Products</Link></li>
              <li><Link to="/how-it-works" className="hover:text-white">How Delivery Works</Link></li>
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-widest text-[#E5B800]">Get Started</h4>
            <ul className="mt-4 space-y-2 text-sm text-emerald-100/80">
              <li><Link to="/request-fuel" className="hover:text-white">Request Fuel Delivery</Link></li>
              <li><Link to="/login" className="hover:text-white">Customer Login</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6 text-xs text-emerald-100/60">
          © {new Date().getFullYear()} RODAIR Investments & Services Limited. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
